module.exports = __webpack_public_path__ + "static/media/10.08f920dd.jpeg";